import { forwardRef } from "react";

import Icon from "@/components/Icon";
import AISearchWithSparkleSVG from "./ai-search-with-sparkle.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const AISearchWithSparkleIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={AISearchWithSparkleSVG} {...props} />;
});

export default AISearchWithSparkleIcon;
